import { css, cx, useTheme } from '@fable/theme'
import { Button, FlexBox } from '@fable/components'
import { SideBarButtons } from './Sidebar'

export const SidebarButtons: React.VFC<{
  buttons?: SideBarButtons[] | null
  className?: string
  attached?: boolean
}> = ({ buttons, className = '', attached = false }) => {
  const { colors, mediaQueries } = useTheme()
  if (!buttons?.length) return null

  return (
    <FlexBox
      justifyContent="flex-end"
      flexDirection="column"
      className={cx(
        css`
          margin: 32px auto 0;
          padding: 0 40px;
          width: 100%;
          button + button {
            margin-top: 10px;
          }
        `,
        !attached
          ? css`
              ${mediaQueries.mobileL} {
                padding-bottom: 40px;
                background-color: ${colors.whiteFang}80;
                position: fixed;
                bottom: 0;
                left: 0;
                z-index: 1;
              }
              ${mediaQueries.tablet} {
                bottom: 70px;
              }
            `
          : '',
        className
      )}
    >
      {buttons.map((x: SideBarButtons, i: number) =>
        // Patched in for backwards compatibility but for most situations you should be able to pass in an array of ButtonProps objects
        x.component ? (
          <div key={i}>{x.component}</div>
        ) : (
          <Button
            key={i}
            {...x}
            width={x.width || '100%'}
            height={x.height || '44px'}
          />
        )
      )}
    </FlexBox>
  )
}
